const consoleConfig = {
  wxRedirectUrl: window.location.origin,
  wxAppid:
    window.location.origin.indexOf("rel") != "-1"
      ? "wxdece083eb692b98d"
      : "wx967424a0e252a640",
  statusList: [40001, 8100, 8101,8801],
};
module.exports = consoleConfig;
